import { store } from 'store'
import { disconnectProvider } from 'store/app/hooks'
import { ApiError, http } from './http'
import { handleError } from './httpHandleError'
import toastify from 'components/Toastify'

http.interceptors.request.use(
  (config) => {
    const state = store.getState()
    const { account } = state
    const { token = '' } = account
    if (token) {
      if (!config.headers) {
        config.headers = {}
      }
      config.headers['Access-Token'] = token
    }
    return config
  },
  (err) => {
    return Promise.reject(err)
  },
)

http.interceptors.response.use(
  (response) => {
    const { data } = response

    const { code = 0, msg = '' } = data

    if (code === 200) {
      return response
    }

    const sessionErrors = [
      // User authorization token invalid, clear all user information
      code === 1009 && msg === 'AUTH_AUTHORIZATION_TOKEN_INVALID',
      // Missing user authorization token, clear all user information
      code === 1009 && msg === 'AUTH_SIGNIN_REQUIRED',
      // User authorization token expires, clear all user information
      code === 1010 && msg === 'HEADER_TOKEN_EXPIRE',
      // Authorization failed, clear all user information
      code === 1003 && msg === 'AUTH_SIGNIN_FAILED',
    ]
    if (sessionErrors.some((v) => v)) {
      toastify.warn('Session expired, please reauthorize.', {
        id: 'session-expired',
      })
      disconnectProvider()
    }

    return Promise.reject(new ApiError(response.data.msg, response.data.code))
  },
  (error) => {
    handleError(error)

    return Promise.reject(error)
  },
)
